export default function inArray(value, array) {
    if (array) {
        return array.indexOf(value) !== -1;
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/common/in-array.js
// module id = 1893
// module chunks = 29